export const usernameUpdateHistory = {
  usernaemUpdateRequests: "Username Update Requests",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  userId: "User ID",
  currentUsername: "Current Username",
  requestedUsername: "Requested Username",
  cancel: "Cancel",
  filter: "Filter",
  requestedBy: "REQUESTED BY",
  requestedDate: "REQUESTED DATE",
  approve: "Approve",
  approvedBy: "Approved By",
  reject: "Reject",
  prviousUsername: "Previous Username",
  status: "Status",
  approvedDate: "Approved Date",
  userId: "User ID",
  selectStatus: "SELECT STATUS",
  all: "ALL",
  approved: "APPROVED",
  rejected: "REJECTED",
};
